import { loadPdfJs } from './loadPdfJs';
import { detectPdfFields, isConfigurablePdfField } from './pdfFieldDetection';

export const countPdfFields = async (file: File): Promise<number | null> => {
	const url = URL.createObjectURL(file);
	try {
		const pdfjsLib = await loadPdfJs();
		const pdf = await pdfjsLib.getDocument(url).promise;
		const fields = await detectPdfFields(pdf);
		pdf.destroy();
		return fields.filter(isConfigurablePdfField).length;
	} catch {
		return null;
	} finally {
		URL.revokeObjectURL(url);
	}
};
